var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItemText = void 0;
var ListItemText_1 = __importDefault(require("./ListItemText"));
exports.ListItemText = ListItemText_1.default;
exports.default = ListItemText_1.default;
//# sourceMappingURL=index.js.map